import React from 'react'
import PropTypes from 'prop-types'
import { component } from 'hoc'
import { Tooltip as TooltipAntd } from 'antd'

const Tooltip = ({
  children, ...props
}) => {
  return (
    <TooltipAntd {...props}>
      {children}
    </TooltipAntd>
  )
}

Tooltip.propTypes = {
  children: PropTypes.object,
}

Tooltip.defaultProps = {
  children: undefined,
}

export default component()(Tooltip)
